import { render, staticRenderFns } from "./Equity.vue?vue&type=template&id=252a3098&scoped=true&"
import script from "./Equity.vue?vue&type=script&lang=js&"
export * from "./Equity.vue?vue&type=script&lang=js&"
import style0 from "./Equity.vue?vue&type=style&index=0&id=252a3098&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252a3098",
  null
  
)

export default component.exports